import { SnackbarOrigin } from 'notistack';

import { ToastVariant } from './types';

export const TOAST_ANCHOR_ORIGIN: SnackbarOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const TOAST_DURATION: Record<ToastVariant, number> = {
  [ToastVariant.SUCCESS]: 4000,
  [ToastVariant.ERROR]: 6000,
  [ToastVariant.WARNING]: 6000,
  [ToastVariant.INFO]: 5000,
};

export const TOAST_ARIA_LIVE: Record<ToastVariant, 'assertive' | 'polite'> = {
  [ToastVariant.SUCCESS]: 'polite',
  [ToastVariant.ERROR]: 'assertive',
  [ToastVariant.WARNING]: 'assertive',
  [ToastVariant.INFO]: 'polite',
};
